import LawListItem from './LawListItem'

export default LawListItem
